import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  toasts: any[] = [];

  constructor() { }

  message(message: string): void {
    this.show(message, { classname: 'bg-success text-light', delay: 5000 });
  }

  warning(message: string): void {
    this.show(message, { classname: 'bg-warning text-light', delay: 5000 });
  }

  error(message: string): void {
    this.show(message, { classname: 'bg-danger text-light', delay: 10000 });
  }  

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
